import React, { useEffect, useState } from 'react';
import { TechStackIcon } from './TechStackIcon';
import { MeetingType, UIRoundTemplate } from 'types';

interface Props {
	roundTemplates: UIRoundTemplate[];
	setSelectedTechStack: (val: string) => void;
	setIsAIRoundSelected: (val: boolean) => void;
	selectedTeckStack: string;
	showMockTestOnly?: boolean;
	interviewType?: MeetingType | null;
}

export const RecommendTechStack = ({
	roundTemplates,
	setSelectedTechStack,
	selectedTeckStack,
	setIsAIRoundSelected,
	showMockTestOnly,
	interviewType,
}: Props) => {
	const [filteredRoundTemplates, setFilteredRoundTemplates] = useState<UIRoundTemplate[]>([]);

	useEffect(() => {
		const filtered =
			roundTemplates?.filter(
				el =>
					(!interviewType ||
						(interviewType === MeetingType.Assessment
							? el?.templateType === MeetingType.Assessment
							: el?.templateType !== MeetingType.Assessment)) &&
					(showMockTestOnly ? el.isMock : !el.isMock),
			) ?? [];

		setFilteredRoundTemplates(filtered);

		if (filtered?.length) {
			setSelectedTechStack(filtered[0]?._id);
			setIsAIRoundSelected(filtered[0]?.isAIInterviewTemplate || filtered[0]?.templateType === MeetingType.Assessment);
		}
	}, [roundTemplates, interviewType, showMockTestOnly]);

	return (
		<div className="flex flex-col gap-2">
			<p className="text-[15px] pb-3 font-[500] dark:text-[#C7C9D9]">Select your round</p>
			<div className="w-full flex flex-wrap gap-4">
				{filteredRoundTemplates.length ? (
					filteredRoundTemplates.map(rT => (
						<TechStackIcon
							key={rT._id}
							setSelectedTechStack={setSelectedTechStack}
							setIsAIRoundSelected={setIsAIRoundSelected}
							selectedTeckStack={selectedTeckStack}
							roundTemplate={rT}
						/>
					))
				) : (
					<div>No tech stacks found for your experience</div>
				)}
			</div>
		</div>
	);
};
